import style from './P2PContactCardListSkeleton.css';
import Skeleton from '../../shared/Skeleton/Skeleton';
import ListingSkeleton from '../../shared/ListingSkeleton/ListingSkeleton';

export default function P2PContactCardListPageSkeleton({ className = '' }) {
  return (
    <div className={`${className} ${style.container}`}>
      <Skeleton
        radius={'81px'}
        width={'283px'}
        height={'24px'}
        className={style.title}
      />
      <Skeleton
        radius={'81px'}
        width={'165px'}
        height={'16px'}
        className={style.subtitle}
      />
      <ListingSkeleton items={3} className={style.list} withTitle={false} />
    </div>
  );
}
